export const formatActionText = (action: string, phase: string) =>
  `‘${action}’ added to ‘${phase}’ Phase`;
